<template>
  <div class="progress">
    <div class="progress-bar bg-warning" role="progressbar" :style="`width: ${facture/total*100}%`"></div>
    <div class="progress-bar bg-primary" role="progressbar" :style="`width: ${paye/total*100}%`"></div>
    <div class="progress-bar bg-success" role="progressbar" :style="`width: ${reverse/total*100}%`"></div>
    <div class="progress-bar" style="background-color: #d4d4d4;" role="progressbar" :style="`width: ${non_facture/total*100}%`"></div>
  </div>
</template>

<script>
export default {
  name: 'RepartitionBar',
  props: {
    total: {
      type: Number,
      default: 100
    },
    facture: {
      type: Number,
      default: 0
    },
    paye: {
      type: Number,
      default: 0
    },
    reverse: {
      type: Number,
      default: 0
    },
    non_facture: {
      type: Number,
      default: 0
    }
  }
}
</script>